/*
 * Copyright (c) 2017 Edelweiss72 GmbH - All Rights Reserved
 * Unauthorized usage or distribution of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 *
 * @author Wladimir Eberts <w.eberts@edelweiss72.de>
 */

(function ($)
{
    $(function ()
    {
        const $form = $('.mod-form:not(.no-clear)');

        $form
            .on('dynamic.clear', function (event, $clone)
            {
                $clone.find('.m-item:not(.no-clear) .m-input > input:not([type="button"]):not([type="checkbox"]):not([type="file"]):not([type="hidden"]):not([type="image"]):not([type="password"]):not([type="radio"]):not([type="range"]):not([type="submit"])')
                    .each(function ()
                    {
                        const
                            $input = $(this),
                            $button = $('<button type="button" class="m-clear"></button>');

                        $button
                            .on('focusin.states focusout.states change.states blur.states input.states', function (event)
                            {
                                event.stopImmediatePropagation();
                            })
                            .on('click', function (event)
                            {
                                event.preventDefault();

                                $input.val('').trigger('change').focus();
                            })
                            .insertAfter($input);
                    });
            })
            .trigger('dynamic.clear', [$form]);
    });
})(jQuery);
